import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GUIDE_URL } from "../../settings/APISetting";
import { sortByProp } from "../../settings/themeSettings";
import api from "../../config/axiosConfig";



export const fetchGuides = createAsyncThunk('fetch-guides', async (page = 1) => {
    const response = await api.get(GUIDE_URL);
    return response.data;
});
export const createGuide = (guide, err, cb) => {
    api.post(GUIDE_URL, guide)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const updateGuide = (guide, err, cb) => {
    api.put(`${GUIDE_URL}/${guide.id}`, guide)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const deleteGuide = (id, err, cb) => {
    api.delete(`${GUIDE_URL}/${id}`)
        .then((response) => {
            if (cb) cb(response);
        })
        .catch((error) => {
            if (err) err(error);
        });
}




const guideSlice = createSlice({

    name: 'guides',
    initialState: { guides: [], guidesFetchStatus: '' },

    reducers: {
        addGuide: (state, action) => {
            state.guides = [...state.guides, action.payload].sort((a,b) => sortByProp(a,b,'nomComplet'));
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchGuides.fulfilled, (state, action) => {
            if (Array.isArray(action.payload)) {
                state.guides = [...action.payload].sort((a, b) => sortByProp(a, b, 'nomComplet'));
                state.guidesFetchStatus = 'success';
            } else {
                console.error("fetchGuides payload is not an array:", action.payload);
                state.guides = [];
                state.guidesFetchStatus = 'error';
            }
        }).addCase(fetchGuides.pending, (state, action) => {
            state.guidesFetchStatus = 'loading';

        }).addCase(fetchGuides.rejected, (state, action) => {

            state.guidesFetchStatus = 'error';

        });
    }


});
export const { addGuide } = guideSlice.actions;
export default guideSlice;